<template>
  <DetailCryptoTransaction />
</template>

<script>
import DetailCryptoTransaction from '../../../components/crypto/DetailCryptoTransaction.vue'
export default {
  components: {
    DetailCryptoTransaction,
  },
}
</script>

<style scoped lang="scss"></style>
